import React from "react";
import "./PGAModelBuilderCalcGlossary.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import StatTable from "../../../../../../StatTable";

const GLOSSARY = graphql`
  query PGAModelBuilderCalcGlossaryQuery {
    pgaModelCalculationsOverview {
      classification {
        id
        name
      }

      name
      key
      glossaryEntry
    }
  }
`;

export default function PGAModelBuilderCalcGlossary() {
  const data = useLazyLoadQuery(GLOSSARY);

  const tableData = React.useMemo(() => {
    return data.pgaModelCalculationsOverview.map((calculation) => {
      const newObj = { ...calculation };

      newObj.classificationName = calculation.classification.name;

      return newObj;
    });
  }, []);

  let columns = [
    {
      Header: "Term",
      accessor: "name",
    },
    {
      Header: "Class",
      accessor: "classificationName",
    },
    {
      Header: "Definition",
      accessor: "glossaryEntry",
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <StatTable data={tableData} columns={columns} />
    </div>
  );
}
